import { registerValidator } from '@philips-emr/tws-core/lib/services/model-service';

const EMAIL_VALIDATOR = 'emailValidator';
const PATTERN = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/g;

export default registerValidator('email-validator', (value: string) => {
  if (!value) {
    return [];
  }

  const valid = Boolean((value).match(PATTERN));

  return [
    {
      message: !valid ? 'provider.invalid-email' : '',
      name: EMAIL_VALIDATOR,
      valid,
    },
  ];
});
